module.exports = __webpack_public_path__ + "static/img/loginbj.f8258b8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img2/loginbj.png
// module id = pr1K
// module chunks = 3